import React from 'react';
import { addYears, format, subYears } from 'date-fns';
import { useIntl } from 'react-intl';
import DateInput, { DateChangeEvent } from 'carbon-react/lib/components/date';

import { MAX_FUTURE_YEARS_FOR_ASSUMPTIONS, MIN_PREV_YEARS_FOR_ASSUMPTIONS } from '../../../../../core/constants';
import styles from '../repeating-method.scss';
import { forceLocalDate } from '../../../../../utils/dates';

interface StartDateProps {
  disabled?: boolean;
  onChange: (date: Date) => void;
  value: Date;
}

const MAX_DATE = addYears(Date.now(), MAX_FUTURE_YEARS_FOR_ASSUMPTIONS);
const MIN_DATE = subYears(Date.now(), MIN_PREV_YEARS_FOR_ASSUMPTIONS);

export const StartDate = ({ disabled, onChange, value }: StartDateProps) => {
  const intl = useIntl();

  const handleDateChange = (e: DateChangeEvent) => onChange?.(forceLocalDate(e.target.value.rawValue || ''));

  return (
    <div className={styles.carbonDate}>
      <DateInput
        disabled={disabled}
        label={intl.formatMessage({ id: 'common.start_date', defaultMessage: 'Start date' })}
        id="fromDate"
        value={intl.formatDate(typeof value === 'string' ? forceLocalDate(value) : value, {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        })}
        onChange={handleDateChange}
        maxDate={format(MAX_DATE, 'yyyy-MM-dd')}
        minDate={format(MIN_DATE, 'yyyy-MM-dd')}
        disablePortal={false}
        maxWidth="185px"
        size="large"
      />
    </div>
  );
};
